import { useForm, ValidationError } from "@formspree/react";
import { useNavigate } from "react-router";

// import pages
import SubHeader from "../layout/SubHeader";
import SubFooter from "../layout/SubFooter";
import SubTitle from "../../components/SubTitle";

const AskBenSensei = () => {
  const router = useNavigate();
  const [state, handleSubmit] = useForm(
    process.env.REACT_APP_FORMSPREE_QUESTION_ID
  );

  if (state.succeeded) {
    setTimeout(() => {
      router("/thanks");
    }, 500);
  }

  return (
    <div className="askbensensei-section">
      <SubHeader />
      <div className="container askbensensei-main-section">
        <SubTitle title="Ask Ben-sensei!" subTitle="ベン先生に聞いてみよう！" />
        <form onSubmit={handleSubmit} className="askbensensei-content-section">
          <div className="field">
            <input
              type="text"
              className="input-text font-outfit"
              placeholder="Name"
              name="name"
              id="name"
              required
            />
          </div>
          <div className="field">
            <input
              type="email"
              className="input-text font-outfit"
              placeholder="Email address"
              name="email"
              id="email"
              required
            />
          </div>
          <ValidationError prefix="Email" field="email" errors={state.errors} />
          <div className="field">
            <input
              type="email"
              name="emailConfirm"
              id="emailConfirm"
              className="input-text font-outfit"
              placeholder="Confirm email address"
              required
            />
          </div>
          <div className="field">
            <input
              type="text"
              className="input-text font-outfit"
              placeholder="Question/Topic"
              name="topic"
              id="topic"
            />
          </div>
          <div className="field">
            <textarea
              className="input-textarea font-outfit"
              placeholder="Type your message..."
              rows={3}
              name="message"
              id="message"
              required
            ></textarea>
          </div>{" "}
          <ValidationError
            prefix="Message"
            field="message"
            errors={state.errors}
          />
          <div className="field">
            <div className="button-text">
              <button
                type="submit"
                disabled={state.submitting}
                className="footer-btn font-amaticsc-bold"
              >
                Submit
                <span className="btn-text font-amaticsc-bold">送信</span>
              </button>
            </div>
          </div>
        </form>
      </div>
      <SubFooter />
    </div>
  );
};

export default AskBenSensei;
